import * as FaIcons from "react-icons/fa";

const FaWhatsapp = FaIcons.FaWhatsapp as unknown as React.FC<{ className?: string }>;
const FaEnvelope = FaIcons.FaEnvelope as unknown as React.FC<{ className?: string }>;
const FaMapMarkerAlt = FaIcons.FaMapMarkerAlt as unknown as React.FC<{ className?: string }>;

const PHONE_HUMAN = "+56 9 7523 9696";
const PHONE = "56975239696";
const EMAIL = "murysotomayor@gmail.com";
const WHATSAPP_TEXT = encodeURIComponent("¡Hola Muriel! Me gustaría agendar unos días de arriendo.");

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-8 mt-20">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        {/* izquierda: info */}
        <div className="text-center md:text-left">
          <p className="text-sm md:text-base text-white">
            © {new Date().getFullYear()} Muriel Soto · Encargada de la Pérgola del Sol
          </p>

          <div className="flex flex-col md:flex-row gap-4 items-center md:items-start mt-3 text-sm">
            <a
              className="inline-flex items-center gap-2 hover:text-white"
              href={`https://wa.me/${PHONE}?text=${WHATSAPP_TEXT}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp className="text-green-400" /> {PHONE_HUMAN}
            </a>

            <a
              className="inline-flex items-center gap-2 hover:text-white"
              href={`mailto:${EMAIL}`}
            >
              <FaEnvelope className="text-blue-400" /> {EMAIL}
            </a>

            <span className="inline-flex items-center gap-2">
              <FaMapMarkerAlt className="text-red-400" />
              "Cabaña Pérgola del Sol, Parcela 24, Los Molles, Santa María, Provincia de Petorca, Chile"
            </span>
          </div>
        </div>

        {/* derecha: estadísticas */}
        <div className="flex flex-col md:flex-row gap-3 md:gap-5 text-center">
          <div className="bg-white/10 px-5 py-3 rounded-xl border border-white/10 backdrop-blur-sm shadow-sm">
            <span className="text-2xl font-bold text-blue-400">+</span>
            <span className="ml-2 text-gray-100 text-base">Perfectas condiciones</span>
          </div>

          <div className="bg-white/10 px-5 py-3 rounded-xl border border-white/10 backdrop-blur-sm shadow-sm">
            <span className="text-2xl font-bold text-green-400">+</span>
            <span className="ml-2 text-gray-100 text-base">Todo limpio e higiénico</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
